module.exports = __webpack_public_path__ + "assets/Edit.7c57dd7f21ad615329c01fff2d1c9a6c.svg";